/* eslint-disable camelcase */

const Icons = {
  columnMoveMove: '<i class="ag-row-dragging-icon-window"></i>'
};

export default Icons;
